import { useSelector } from "./hooks.ts";
import * as selectors from "./selectors.ts";

export interface UseCalculationStateProps {
    offeringSku: string;
}

export function useCalculationState(props: UseCalculationStateProps) {
    const { offeringSku } = props;
    return {
        billingCycle: useSelector(selectors.getBillingCycle),
        isUnitCountAboveMaxThreshold: useSelector((ctx) =>
            selectors.isUnitCountAboveMaxThreshold(ctx, offeringSku)
        ),
        unitCountMin: useSelector((ctx) =>
            selectors.getUnitCountMinThreshold(ctx, offeringSku)
        ),
        isUnitCountBelowMinThreshold: useSelector((ctx) =>
            selectors.isUnitCountBelowMinThreshold(ctx, offeringSku)
        ),
        price: useSelector((ctx) =>
            selectors.getFormattedPlanPrice(ctx, offeringSku)
        ),
        recommended: useSelector((ctx) =>
            selectors.isOfferingRecommended(ctx, offeringSku)
        ),
        unitCount: useSelector((ctx) => selectors.getUnitCount(ctx)),
        unitTierLowerBound: useSelector((ctx) =>
            selectors.getUnitTierLowerBound(ctx, offeringSku)
        ),
        unitTierUpperBound: useSelector((ctx) =>
            selectors.getUnitTierUpperBound(ctx, offeringSku)
        ),
        unitsAvailableInTier: useSelector((ctx) =>
            selectors.getUnitsAvailableInTier(ctx, offeringSku)
        ),
        numberFormatLocale: useSelector(selectors.getNumberFormatLocale)
    };
}
